import ResetPasswordService from "../services/resetPasswordService";

export function reset(emailOrUsername) {
  return (dispatch, getstate) => {
    dispatch({ type: "RESETPASSWORD_INIT" });

    var params = {
      lang: encodeURIComponent(navigator.language),
      orgid: encodeURIComponent(getstate().config.registration.orgid),
    };
    if (emailOrUsername.indexOf("@") < 0) {
      params = {
        ...params,
        username: encodeURIComponent(emailOrUsername),
      };
    } else {
      params = {
        ...params,
        email: encodeURIComponent(emailOrUsername),
      };
    }

    ResetPasswordService.requestResetPassword(
      params,
      getstate().config.server,
      dispatch
    )
      .done(() => {
        dispatch({ type: "RESETPASSWORD_SUCCESS" });
      })
      .fail((xhr, ajaxOptions, thrownError) => {
        dispatch({ type: "RESETPASSWORD_ERROR", payload: thrownError });
        dispatch({ type: "RESETPASSWORD_RECAPTCHA_INVALID" });
      });
  };
}

export function setNewPassword(uid, key, password) {
  return (dispatch, getstate) => {
    dispatch({ type: "NEWPASSWORD_INIT" });

    var params = {
      key: encodeURIComponent(key),
      password: encodeURIComponent(password),
      uid: encodeURIComponent(uid),
    };

    ResetPasswordService.setNewPassword(
      params,
      getstate().config.server,
      dispatch
    )
      .done(() => {
        dispatch({ type: "NEWPASSWORD_SUCCESS" });
      })
      .fail((xhr, ajaxOptions, thrownError) => {
        dispatch({ type: "NEWPASSWORD_ERROR", payload: thrownError });
      });
  };
}






// WEBPACK FOOTER //
// ./src/actions/resetPasswordActions.js